import { TFunction } from 'i18next';
import { getScooterColor } from '../../helpers/scooter-markers-helper';
import { ScooterStatus, ScooterColorKeys } from '../../pages/ZonesPage/interface';

type StatusSource = { lock?: boolean; newStatus?: string };

// Статус рядка історії: явний newStatus, інакше похідний від lock
export const getLockHistoryStatus = (row: StatusSource) => {
  if (!row?.newStatus || row.newStatus.length === 0) {
    return row?.lock ? 'BLOCKED' : 'UNLOCKED';
  }
  return row.newStatus;
};

export const getLockHistoryStatusLabel = (status: string, t: TFunction) => {
  switch (status) {
    case 'AVAILABLE':
      return t('lockHistory.statusActiveForRent');
    case 'CHARGING':
      return t('lockHistory.statusOnCharge');
    case 'TRANSPORTING':
      return t('lockHistory.statusTransport');
    case 'MAINTENANCE':
      return t('lockHistory.statusInRepair');
    case 'BROKEN_IN_CITY':
      return t('lockHistory.statusBrokenInCity');
    case 'LOW_BATTERY':
      return t('lockHistory.statusLowBattery');
    case 'HIDDEN':
      return t('lockHistory.statusHidden');
    case 'BLOCKED':
      return t('lockHistory.statusBlocked');
    case 'UNLOCKED':
      return t('lockHistory.statusUnlocked');
    default:
      return status;
  }
};

const getStatusColorKey = (status: string): ScooterColorKeys => {
  switch (status) {
    case 'AVAILABLE':
      return 'free';
    case 'CHARGING':
      return ScooterStatus.CHARGING;
    case 'TRANSPORTING':
      return ScooterStatus.TRANSPORTING;
    case 'MAINTENANCE':
      return ScooterStatus.MAINTENANCE;
    case 'BROKEN_IN_CITY':
      return ScooterStatus.BROKEN_IN_CITY;
    case 'LOW_BATTERY':
      return 'discharged';
    case 'HIDDEN':
      return ScooterStatus.HIDDEN;
    case 'UNLOCKED':
      return 'unlocked';
    default:
      return 'all';
  }
};

const getIconColor = (backgroundColor: string): string => {
  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness > 128 ? '#000000' : '#FFFFFF';
};

// Функція для отримання тексту та кольору статусу
export const getLockHistoryStatusDisplay = (status: string, t: TFunction) => {
  const bgcolor = getScooterColor(getStatusColorKey(status));

  return {
    label: getLockHistoryStatusLabel(status, t),
    color: getIconColor(bgcolor),
    bgcolor
  };
};
